import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import Select from 'react-select';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import FormInputMobile from 'modules/common/components/FormInputMobile';
import moment from 'moment';
import { customStyle, formatNumber } from 'helper';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import InputMask from 'react-input-mask';
import useFormValidator from 'useFormValidator';
import CmsContext from 'context/CmsContext';
import Address from 'modules/common/address/Address';
import ViolationsList from './ViolationsList';
import ViolationsContext from './ViolationsContext';
import ApprehendingOfficerDropdownUpdate from '../components/ApprehendingOfficerDropdownUpdate';
import * as actions from '../action';
import * as c from '../constant';

function UpdateViolationTicketModal({
  getViolationsList,
  updateViolations,
  showTransactionTrafficViolator,
  formData,
  updateList,
  setFormData,
  id,
  updating,
  transaction,
  municipalityListApp,
  barangayListApp,
  getMunicipalityListApp,
  getBarangayListApp,
}) {
  const firstDateOfLastYear = `1/1/${new Date().getFullYear() - 1}`;

  const setModal = useContext(ModalContext);
  const cmsContext = useContext(CmsContext);
  const CMS_MASKINGS = cmsContext.findByType('MASKINGS');
  const [formMobile, setFormMobile] = useState({});

  const [violations, setViolations] = useState([]);
  const violationsValue = { violations, setViolations };

  const validateForm = useFormValidator(formData, {
    // driver_license_validity_date_from: 'required',
    // driver_license_validity_date_to: 'required',
    ovr_number: `required|mask:${_.get(
      CMS_MASKINGS,
      'OVR_NUMBER_REGEX'
    )}~${_.get(CMS_MASKINGS, 'OVR_NUMBER')}`,
    // birth_date: 'required',
    last_name: 'required',
    first_name: 'required',
    driver_license_number: `required|mask:${_.get(
      CMS_MASKINGS,
      'OVR_DRIVER_LICENSE_NUMBER_REGEX'
    )}~${_.get(CMS_MASKINGS, 'OVR_DRIVER_LICENSE_NUMBER')}`,
    apprehended_at: 'required|apprehended_at_before',
    vehicle_type: 'required',
    vehicle_plate_number: 'required',
    apprehending_officer_id: 'required',
    apprehension_municipality_code: 'required',
    apprehension_barangay_code: 'required',
    apprehension_street: 'required',
  });

  const mobileNumberValidator = useFormValidator(formMobile, {
    mobile_number: 'required|cellphone_number',
  });

  const [municipalityApp, setMunicipalityApp] = useState({
    label:
      _.get(
        transaction,
        'included.apprehension_municipality.attributes.name'
      ) || '',
    value:
      _.get(
        transaction,
        'included.apprehension_municipality.attributes.code'
      ) || '',
  });

  const [barangayApp, setBarangayApp] = useState({
    label:
      _.get(transaction, 'included.apprehension_barangay.attributes.name') ||
      '',
    value:
      _.get(transaction, 'included.apprehension_barangay.attributes.code') ||
      '',
  });

  const createDropdown = list => {
    const newList = [];
    list.map(data => {
      return newList.push({
        label: data.attributes.name,
        value: data.attributes.code,
      });
    });
    return newList;
  };

  const handleMunicipalityAppSelect = e => {
    setMunicipalityApp(e);
    setFormData({
      ...formData,
      apprehension_municipality_code: e.value,
    });
    getBarangayListApp(
      {
        display_all: 1,
        region_code: _.get(formData, 'apprehension_region_code'),
        province_code: _.get(formData, 'apprehension_province_code'),
        municipality_code: e.value
      }
    );
  };

  const handleBarangayAppSelect = e => {
    setBarangayApp(e);
    setFormData({
      ...formData,
      apprehension_barangay_code: e.value,
    });
  };

  const handleOnChangeDate = key => ({ target: { value } }) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const handleOnSubmit = e => {
    e.preventDefault();
    const violationCode = violations.map(item => {
      return { violation_code: item.violation_code };
    });

    if (!validateForm.response.is_passed) {
      return false;
    }

    const formatForm = {
      ...formData,
      apprehended_at: `${moment(_.get(formData, 'apprehended_at')).format(
        'YYYY-MM-DD HH:mm'
      )}:00`,
      driver_license_validity_date_from:
        _.get(formData, 'driver_license_validity_date_from') || '',
      driver_license_validity_date_to:
        _.get(formData, 'driver_license_validity_date_to') || '',
      birth_date: _.get(formData, 'birth_date') || '',
      mobile_number: formatNumber(_.get(formMobile, 'mobile_number')),
      ovr_number: _.get(formData, 'ovr_number').toUpperCase(),
      driver_license_number: _.get(
        formData,
        'driver_license_number'
      ).toUpperCase(),
      violations: violationCode,
    };
    return updateViolations(id, formatForm, () => {
      setModal({ isOpen: false });
      showTransactionTrafficViolator(id);
      getViolationsList();
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onSetFormData = () => {
    setFormMobile({
      mobile_number: formatNumber(_.get(updateList, 'mobile_number')),
    });

    if (!_.isEmpty(updateList)) {
      setFormData({
        ...formData,
        ovr_number: _.get(transaction, 'attributes.ovr_number'),
        last_name: _.get(updateList, 'last_name'),
        first_name: _.get(updateList, 'first_name'),
        middle_name: _.get(updateList, 'middle_name'),
        extension_name: _.get(updateList, 'extension_name'),
        street: _.get(updateList, 'street'),
        driver_license_number: _.get(updateList, 'driver_license_number'),
        vehicle_type: _.get(updateList, 'vehicle_type'),
        vehicle_plate_number: _.get(updateList, 'vehicle_plate_number'),
        apprehension_street: _.get(updateList, 'apprehension_street'),
        apprehending_officer: _.get(
          transaction,
          'included.apprehending_officer.attributes.name'
        ),
        apprehending_officer_id: _.get(updateList, 'apprehending_officer_id'),
        discount: _.get(updateList, 'discount'),
        birth_date: _.get(updateList, 'birth_date')
          ? `${moment(_.get(updateList, 'birth_date')).format('MM/DD/YYYY')}`
          : '',
        driver_license_validity_date_from: _.get(
          updateList,
          'driver_license_validity_date_from'
        )
          ? `${moment(
            _.get(updateList, 'driver_license_validity_date_from')
          ).format('MM/DD/YYYY')}`
          : '',
        driver_license_validity_date_to: _.get(
          updateList,
          'driver_license_validity_date_to'
        )
          ? `${moment(
            _.get(updateList, 'driver_license_validity_date_to')
          ).format('MM/DD/YYYY')}`
          : '',
        apprehended_at:
          `${moment(_.get(updateList, 'apprehended_at')).format(
            'MM/DD/YYYY HH:mm'
          )}` || '',
      });
      setViolations(_.get(updateList, 'violations') || []);
    }
  };

  useEffect(() => {
    onSetFormData();
  }, []);

  useEffect(() => {
    getMunicipalityListApp({ province_code: 133900000 });
  }, []);
  useEffect(() => {
    getBarangayListApp({
      municipality_code: _.get(
        transaction,
        'attributes.apprehension_municipality_code'
      ),
    });
  }, []);

  const handleDropDownChange = key => e => {
    if (key === 'apprehending_officer_id') {
      setFormData({
        ...formData,
        apprehending_officer: e.label,
        [key]: e ? e.value : '',
      });
      return false;
    }
    return setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  };
  const onChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value.toUpperCase(),
    });
  };

  const onChangeText = e => {
    // remove underscore: quick fix
    const currenOnChangeValue = e.target.value.includes('_')
      ? e.target.value.replace(/_/g, '')
      : e.target.value;

    setFormData({
      ...formData,
      [e.target.name]: currenOnChangeValue,
    });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  const onChangeAddress = e => {
    setFormData({
      ...formData,
      region_code: e.target.value.region_code,
      province_code: e.target.value.province_code,
      municipality_code: e.target.value.municipality_code,
      barangay_code: e.target.value.barangay_code,
      street: e.target.value.street || '',
    });
  };

  const handleOnChangeDropdown = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <label className="form-label">
          Ordinance Violation Information{' '}
          {validateForm.renderMessage('ovr_number')}
        </label>
        <div className="row">
          <div className="input-group mb-3 col-4">
            <InputMask
              mask={_.get(CMS_MASKINGS, 'OVR_NUMBER')}
              required
              className="form-control"
              value={_.get(formData, 'ovr_number') || ''}
              name="ovr_number"
              onChange={onChangeText}
              alwaysShowMask={false}
              style={{ textTransform: 'uppercase' }}
            />
          </div>
        </div>
        <label className="text-primary font-weight-bold">
          Personal Information
        </label>
        <div className="row pb-3">
          <div className="col-4 pt-1 form-group">
            <label className="form-label">
              Last Name: {validateForm.renderMessage('last_name')}
            </label>
            <input
              className="form-control"
              type="text"
              name="last_name"
              onChange={onChange}
              value={_.get(formData, 'last_name') || ''}
            />
          </div>
          <div className="col-4 pt-1 form-group">
            <label className="form-label">
              First Name: {validateForm.renderMessage('first_name')}
            </label>
            <input
              className="form-control"
              type="text"
              name="first_name"
              onChange={onChange}
              value={_.get(formData, 'first_name') || ''}
            />
          </div>
          <div className="col-4 pt-1 form-group">
            <label className="form-label">Middle Name:</label>
            <input
              className="form-control"
              type="text"
              name="middle_name"
              onChange={onChange}
              value={_.get(formData, 'middle_name') || ''}
            />
          </div>
          <div className="col-4 pt-1 form-group">
            <label className="form-label">Extension Name</label>
            <Select
              options={c.EXTENSION_NAMES}
              // styles={customStyle}
              placeholder="Select Extension name"
              value={{
                label: _.get(formData, 'extension_name') || '',
                value: _.get(formData, 'extension_name') || '',
              }}
              onChange={handleDropDownChange('extension_name')}
            />
          </div>
          <div className="col-4 pt-1 form-group">
            <label className="form-label">
              Birth Date:
              {/* {validateForm.renderMessage('birth_date')} */}
            </label>
            <DateInputPicker
              className="full-input"
              dateFormat="MM/DD/YYYY"
              onChange={handleOnChangeDate('birth_date')}
              value={_.get(formData, 'birth_date') || ''}
            />
          </div>
          <div className="col-4 pt-1 form-group">
            <label className="form-label">
              Mobile Number:{' '}
              {mobileNumberValidator.renderMessage('mobile_number')}
            </label>
            <FormInputMobile
              disableDropdown={false}
              autoComplete="off"
              autoFocus
              type="tel"
              name="mobile_number"
              onChange={setFormMobile}
              value={_.get(formMobile, 'mobile_number') || ''}
            />
          </div>
        </div>
        <label className="text-primary font-weight-bold">Address</label>
        <div className="row pb-3">
          <div className="container-fluid">
            <Address
              value={{
                region_code: _.get(formData, 'region_code') || '',
                province_code:
                  _.get(formData, 'province_code') || '',
                municipality_code:
                  _.get(formData, 'municipality_code') || '',
                barangay_code:
                  _.get(formData, 'barangay_code') || '',
              }}
              onChange={onChangeAddress}
              type="Address"
              region_name="region_code"
              province_name="province_code"
              municipality_name="municipality_code"
              barangay_name="barangay_code"
              name="address"
              removeLabel
            />
          </div>
        </div>
        <label className="text-primary font-weight-bold">
          Vehicle Information
        </label>
        <div className="row pb-3">
          <div className="col-4 pt-2 form-group">
            <label className="form-label pb-1">
              Vehicle Type {validateForm.renderMessage('vehicle_type')}
            </label>
            <Select
              options={c.VEHICLE_TYPE}
              styles={customStyle}
              placeholder="Select Vehicle Type"
              value={{
                label: _.get(formData, 'vehicle_type') || '',
                value: _.get(formData, 'vehicle_type') || '',
              }}
              name="vehicle_type"
              onChange={handleDropDownChange('vehicle_type')}
            />
          </div>
          <div className="col-4 pt-2 form-group">
            <label className="form-label">
              Vehicle Plate Number:{' '}
              {validateForm.renderMessage('vehicle_plate_number')}
            </label>
            <input
              className="form-control"
              type="text"
              name="vehicle_plate_number"
              onChange={onChange}
              value={_.get(formData, 'vehicle_plate_number') || ''}
              required
            />
          </div>
        </div>
        <label className="text-primary font-weight-bold">
          Violation Information
        </label>
        <div className="row pb-3">
          <div className="col-4 pt-2 form-group">
            <label htmlFor="driver_license_number" className="form-label">
              Driver License Number{' '}
              {validateForm.renderMessage('driver_license_number')}
            </label>
            <div className="input-group">
              <InputMask
                className="form-control"
                mask={_.get(CMS_MASKINGS, 'OVR_DRIVER_LICENSE_NUMBER')}
                name="driver_license_number"
                onChange={onChangeText}
                value={_.get(formData, 'driver_license_number') || ''}
                alwaysShowMask={false}
                style={{ textTransform: 'uppercase' }}
              />
            </div>
          </div>
          <div className="col-4 pt-2 form-group">
            <label className="form-label">
              Valid From:{' '}
              {/* {validateForm.renderMessage('driver_license_validity_date_from')} */}
            </label>
            <DateInputPicker
              required
              dateFormat="MM/DD/YYYY"
              className="full-input"
              onChange={handleOnChangeDate('driver_license_validity_date_from')}
              value={_.get(formData, 'driver_license_validity_date_from') || ''}
              maxDate={new Date()}
            />
          </div>
          <div className="col-4 pt-2 form-group">
            <label className="form-label">
              Valid To:{' '}
              {/* {validateForm.renderMessage('driver_license_validity_date_to')} */}
            </label>
            <DateInputPicker
              required
              dateFormat="MM/DD/YYYY"
              className="full-input"
              onChange={handleOnChangeDate('driver_license_validity_date_to')}
              value={_.get(formData, 'driver_license_validity_date_to') || ''}
              maxDate={new Date()}
            />
          </div>
        </div>
        <div className="row pb-3">
          <div className="col-6 pt-2 form-group">
            <label className="form-label">
              Date of Apprehension{' '}
              {validateForm.renderMessage('apprehended_at')}
            </label>
            <DateInputPicker
              withTime
              required
              dateFormat="MM/DD/YYYY HH:mm"
              className="full-input"
              onChange={handleOnChangeDate('apprehended_at')}
              value={_.get(formData, 'apprehended_at')}
              minDate={new Date(firstDateOfLastYear)}
              maxDate={new Date()}
            />
          </div>
          <div className="col-6 pt-2 form-group">
            <label className="form-label">Apprehending Officer {' '} {validateForm.renderMessage('apprehending_officer_id')}</label>
            <ApprehendingOfficerDropdownUpdate
              name="apprehending_officer_id"
              onChange={handleOnChangeDropdown}
              value={+_.get(formData, 'apprehending_officer_id') || ''}
            />
          </div>
        </div>
        <label className="text-primary font-weight-bold">
          Address Information
        </label>
        <div className="row pb-3">
          <div className="col-4 pt-1 form-group">
            <label className="form-label"> Municipality:</label>
            <div>
              <Select
                options={createDropdown(municipalityListApp)}
                styles={customStyle}
                placeholder="Select Municipality"
                value={municipalityApp}
                onChange={e => {
                  handleMunicipalityAppSelect(e);
                }}
              />
            </div>
          </div>
          <div className="col-4 pt-1 form-group">
            <label className="form-label"> Barangay:</label>
            <div>
              <Select
                options={createDropdown(barangayListApp)}
                styles={customStyle}
                placeholder="Select Barangay"
                value={barangayApp}
                onChange={e => {
                  handleBarangayAppSelect(e);
                }}
              />
            </div>
          </div>
          <div className="col-4 pt-1 form-group">
            <label className="form-label">Street:</label>
            <input
              className="form-control"
              type="text"
              name="apprehension_street"
              onChange={onChange}
              value={_.get(formData, 'apprehension_street') || ''}
              required
            />
          </div>
        </div>
        <ViolationsContext.Provider value={violationsValue}>
          <ViolationsList />
        </ViolationsContext.Provider>
        <div className="d-flex justify-content-center">
          <button
            disabled={
              updating ||
              !validateForm.response.is_passed ||
              !mobileNumberValidator.response.is_passed ||
              _.isEmpty(violations)
            }
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateViolationTicketModal.propTypes = {
  getViolationsList: PropTypes.instanceOf(Function).isRequired,
  updateList: PropTypes.instanceOf(Object).isRequired,
  transaction: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  showTransactionTrafficViolator: PropTypes.instanceOf(Function).isRequired,
  updateViolations: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
  updating: PropTypes.bool.isRequired,
  municipalityListApp: PropTypes.instanceOf(Array).isRequired,
  barangayListApp: PropTypes.instanceOf(Array).isRequired,
  getMunicipalityListApp: PropTypes.instanceOf(Function).isRequired,
  getBarangayListApp: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.EDIT_VIOLATIONS) > -1,
  regionsList: _.get(api, `${c.GET_REGION}.list`) || [],
  provinceList: _.get(api, `${c.GET_PROVINCE}.list`) || [],
  municipalityList: _.get(api, `${c.GET_MUNICIPALITIES}.list`) || [],
  barangayList: _.get(api, `${c.GET_BARANGAYS}.list`) || [],
  municipalityListApp: _.get(api, `${c.GET_APP_MUNICIPALITIES}.list`) || [],
  barangayListApp: _.get(api, `${c.GET_APP_BARANGAYS}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateViolationTicketModal);
